import React from "react";
import PropTypes from "prop-types";

function AttendanceSummaryBar({ summary, onMarkAllPresent, canEdit }) {
  const showMarkAllPresent = summary.total > 2;

  return (
    <div className="attendance-page__summary">
      <div className="attendance-page__summary-counts">
        <strong>{summary.total}</strong> uczniów
        <span> - </span><strong className="text-success">{summary.present}</strong> obecnych
        <span> - </span><strong className="text-danger">{summary.absent}</strong> nieobecnych
        <span> - </span><strong className="text-warning">{summary.cancelledOnTime + summary.cancelledLate}</strong> odwołało
        <span> - </span><strong>{summary.unmarked}</strong> niezaznaczonych
      </div>
      {showMarkAllPresent && (
        <button type="button" className="btn btn-outline-secondary" disabled={!canEdit} onClick={onMarkAllPresent}>
          Zaznacz wszystkich jako obecnych
        </button>
      )}
    </div>
  );
}

AttendanceSummaryBar.propTypes = {
  summary: PropTypes.object.isRequired,
  onMarkAllPresent: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
};

export default AttendanceSummaryBar;
